import React, { Component }from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Image, Tabs, Tab, Breadcrumb } from 'react-bootstrap';
import { Field, FieldArray } from 'redux-form';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import { InputField, DisabledInputField } from '../Common/inputField';
import { Selection } from '../Common/selection';
import Dropzone from 'react-dropzone';
import CashFormatter from '../Common/cashFormatter';
import { numberWithCommas } from '../Common/numberWithCommas';
import checkPermission from '../Common/permissions';

class PurchasePaymentDetail extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            files: null,

            tableHeight: window.innerHeight-UI_HEIGHT.twoLineButton,
            productNum: null,
            instock: null,
            purchased: null,
            sold: null,

            rows: [],
            selectedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,
        };

        this.handleResize = this.handleResize.bind(this);
        this.deleteFile = this.deleteFile.bind(this);
    }

    componentDidMount() {
        const { currentReceiveHistory } = this.props;
        window.addEventListener('resize', this.handleResize);
        this.props.resetAttachedFile();
        if (currentReceiveHistory) {
            this.props.fetchReceiveHistoryDetailRecord(currentReceiveHistory.WarehouseReceive_id, currentReceiveHistory.Warehouse_ReceiveCompleted_id);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    componentWillReceiveProps(nextProps) {
      if(nextProps.currentReceiveHistoryDetail != null && nextProps.currentReceiveHistoryDetail != this.props.currentReceiveHistoryDetail){
        let WarehouseReceiveNum = nextProps.currentReceiveHistoryDetail.WarehouseReceiveNum;
        let Name = nextProps.currentReceiveHistoryDetail.Attachments && nextProps.currentReceiveHistoryDetail.Attachments[0];
        let currentReceiveHistoryDetail = nextProps.currentReceiveHistoryDetail;
        if(currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed){
          this.setState({ rows: currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed});
        }
        else {
          this.setState({ rows: currentReceiveHistoryDetail.Warehouse_Receive_Line});
        }
        if(Name)
          this.props.fetchAttachedFile(WarehouseReceiveNum, Name);
      }
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight-UI_HEIGHT.twoLineButton});
    }

    attachmentHeader() {
      return (
        <div>
          <label style={{ cursor: "pointer" }} ><Translate value="attachment_upload" /></label>
        </div>
      )
    }

    renderTable() {
        if (this.props.detailIsLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>
        else {

            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {

                var rows = getRows();
                return Object.assign({}, rows[rowIdx]);
            }

            const onRowSelect = rows => {
                this.setState(...this.state, { selectedRows: rows });
            }

            const onRowsSelected = (rows) => {
                 let newRows = this.state.rows;
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = true;
                 });
                 this.setState({rows: newRows});
            }

             const onRowsDeselected = (rows) => {
                 let newRows = this.state.rows;
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = false;
                 });
                 this.setState({rows: newRows});
             }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
              var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
              this.setState(state);
            }

            const handleFilterChange = filter => {
              let newFilters = Object.assign({}, this.state.filters);
              if (filter.filterTerm) {
                  newFilters[filter.column.key] = filter;
              } else {
                  delete newFilters[filter.column.key];
              }
              this.setState({ filters: newFilters });
            }

            const onRowClick = (rowIdx, row) => {
                this.props.fetchSalesOrders();
            }

            // Handle the editable function

            const handleRowUpdated = e => {
              var rows = [...this.state.rows];
              Object.assign(rows[e.rowIdx], e.updated);
              this.setState({rows:rows});
            }

            // Column difinition

            const columns = [
              {
                  key: 'ProductNum',
                  name: <Translate value="prod_num" />,
                  resizable: true,
                  sortable: true,
                  width: 70,
                  filterable: true
              },
              {
                  key: 'ProductName',
                  name: <Translate value="prod_name" />,
                  resizable: true,
                  sortable: true,
                  width: 160,
                  filterable: true
              },
              {
                  key: 'ProductDescription',
                  name: <Translate value="description" />,
                  resizable: true,
                  sortable: true,
                  width: 120,
                  filterable: true
              },
              {
                  key: 'FOBUnitPrice',
                  name: <Translate value="unit_dollarsign" />,
                  resizable: true,
                  sortable: true,
                  width: 60,
                  filterable: true,
                  formatter: CashFormatter,
              },
              {
                  key: 'RcvQuantity',
                  name: <Translate value="receive_qty" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true
              },
              {
                  key: 'RcvTotalWeight',
                  name: <Translate value="receive_total_wt" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'RcvUnitPrice',
                  name: <Translate value="receive_unit_dollarsign" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true,
                  formatter: CashFormatter,
              },
              {
                  key: 'RcvTotalPrice',
                  name: <Translate value="receive_total_dollarsign" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true,
                  formatter: CashFormatter,
              },
              {
                  key: 'RtnQuantity',
                  name: <Translate value="return_qty" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true
              },
              {
                  key: 'InStock',
                  name: <Translate value="in_stock" />,
                  resizable: true,
                  sortable: true,
                  width: 60,
                  filterable: true
              },
              {
                  key: 'Batch_PONum',
                  name: <Translate value="batch_num" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'Remark',
                  name: <Translate value="remark" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'StorageRate',
                  name: <Translate value="storage_rate" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true
              },
              {
                  key: 'Pallet',
                  name: <Translate value="pallet" />,
                  resizable: true,
                  sortable: true,
                  width: 60,
                  filterable: true
              },
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="PurchasePaymentDetail-dataGrid1">
                    <ReactDataGrid
                        rowKey='BatchNum'
                        enableCellSelect={true}
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowHeight={25}
                        headerRowHeight={45}
                        rowsCount={getSize() }
                        enableRowSelect='single'
                        rowSelection={{
                          showCheckbox: true,
                          enableShiftSelect: true,
                          onRowsSelected: onRowsSelected,
                          onRowsDeselected: onRowsDeselected,
                          selectBy: {
                           isSelectedKey: 'isSelected'
                          }
                       }}
                        minHeight={485} />
                </div></Col></Row>
            )
        }
    }

    onDrop(files) {
        if(this.checkPermission("change_purchase_payment")) {
          alert("You have no permission!");
          return;
        }
        else {
          this.props.attachFile(this.props.currentReceiveHistoryDetail.WarehouseReceiveNum, files);
          this.setState({
              files: files
          });
        }
    }

    onOpenClick() {
          this.refs.dropzone.open();
    }

    deleteFile() {
      let WarehouseReceiveNum = this.props.currentReceiveHistoryDetail.WarehouseReceiveNum;
      let Name = this.props.currentReceiveHistoryDetail.Attachments && this.props.currentReceiveHistoryDetail.Attachments[0];
      this.props.deleteAttachedFile(WarehouseReceiveNum, Name);
    }

    renderPreview() {
        return (
            <div>
              <h4><Translate value="preview" /></h4>
                <hr/>
                <Row><Col sm={ 12 }>
                    <iframe src={this.state.files[0].preview} thumbnail/>
                </Col></Row>
            </div>
        )
    }

    dateStringFormat(date) {
      var month = date.getMonth() + 1;
      if (month < 10)
        month = "0" + month;
      var day = date.getDate();
      if (day < 10)
        day = "0" + day;
      var year = date.getFullYear();
      return month + '/' + day + '/' + year;
    }

    renderPOInformation(){
      let PONum = null, warehouseName = null, purchaser = null, vendorNum = null, vendorName = null, HandlingCost = null, MiscCost = null, ShippingCost = null;
      let vendorDescription = null, OrderDate = null, ETADate = null, CreateDate = null, totalPrice = null, finalPrice = 0;
        PONum = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PONum;
        vendorNum = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorPicklistNum;
        vendorName = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorName;
        vendorDescription = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.VendorDescription;
        HandlingCost = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.HandlingCost;
        MiscCost = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.MiscCost;
        ShippingCost = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.ShippingCost;
        totalPrice = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.TotalPrice;
        finalPrice = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.FinalPrice;

        OrderDate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.OrderDate;
        OrderDate = new Date(OrderDate);

        ETADate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.ETADate;
        ETADate = new Date(ETADate);

        CreateDate = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PostingDate;
        CreateDate = new Date(CreateDate);

        OrderDate = this.dateStringFormat(OrderDate);
        ETADate = this.dateStringFormat(ETADate);
        CreateDate = this.dateStringFormat(CreateDate);
        purchaser = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.Purchaser;
      let POPrice = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.PO_Final_Price;
      let ReceivingPrice = this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.InvoiceFinalPrice;
      return (
        <Panel>
          <Col xs={ 2 }>
            <label className="receive-form-label"><Translate value="details" /></label>
            <Row>
                <label className="col-sm-5 marginTopStyle po-information"><Translate value="receipt_no" /></label>
                <Col sm={ 7 }>
                    <Field name="WarehouseReceiveNum" component={ DisabledInputField }/>
                </Col>
            </Row>
            <Row>
                <label className="col-sm-5 marginTopStyle po-information" ><Translate value="invoice_no" /></label>
                <Col sm={ 7 }>
                    <Field name="InvoiceNum" component={ DisabledInputField }/>
                </Col>
            </Row>
            <Row>
                <label className="col-sm-5 marginTopStyle po-information" ><Translate value="packing_num" /></label>
                <Col sm={ 7 }>
                    <Field name="PackingNum" component={ DisabledInputField }/>
                </Col>
            </Row>
          </Col>
          <Col xs={ 2 }>
              <label className="receive-form-label"><Translate value="purchase" /></label>
              <Row>
                  <Col sm={ 6 }>
                      <label><Translate value="po_num" /></label>
                  </Col>
                  <Col sm={ 6 }>
                    {PONum}
                  </Col>
              </Row>
              <Row>
                  <Col sm={ 6 }>
                      <label><Translate value="purchaser" /></label>
                  </Col>
                  <Col sm={ 6 }>
                      {purchaser}
                  </Col>
              </Row>
              <Row>
                <label className="col-sm-6 marginTopStyle" ><Translate value="note" /></label>
                <Col sm={ 6 }><Field name="Note" component="Textarea" className="form-control" style={{ minHeight: '55px', maxHeight: '55px' }}/></Col>
              </Row>
            </Col>
            <Col xs={ 2 }>
              <label className="receive-form-label"><Translate value="vendor" /></label>
              <Row>
                  <Col sm={ 6 }>
                    <label><Translate value="vendor_id" /></label>
                  </Col>
                  <Col sm={ 6 }>
                    {vendorNum}
                  </Col>
              </Row>
              <Row>
                  <Col sm={ 6 }>
                    <label><Translate value="name" /></label>
                  </Col>
                  <Col sm={ 6 }>
                    {vendorName}
                  </Col>
              </Row>
              <Row>
                  <Col sm={ 6 }>
                    <label><Translate value="description" /></label>
                  </Col>
                  <Col sm={ 6 }>
                    {vendorDescription}
                  </Col>
              </Row>
            </Col>
            <Col xs={ 2 }>
              <label className="receive-form-label"><Translate value="dates" /></label>
              <Row>
                  <Col sm={ 6 }>
                    <label><Translate value="order_date" /></label>
                  </Col>
                  <Col sm={ 6 }>
                    {OrderDate}
                  </Col>
              </Row>
              <Row>
                  <Col sm={ 6 }>
                    <label><Translate value="eta_date" /></label>
                  </Col>
                  <Col sm={ 6 }>
                    {ETADate}
                  </Col>
              </Row>
              <Row>
                  <Col sm={ 6 }>
                    <label><Translate value="create_date" /></label>
                  </Col>
                  <Col sm={ 6 }>
                    {CreateDate}
                  </Col>
              </Row>
            </Col>
            <Col xs={ 2 }>
              <label className="receive-form-label"><Translate value="shipping_cost" /></label>
              <Row>
                <Col sm={ 6 }>
                  <label><Translate value="handling" /><span className="dollar-sign">$$</span></label>
                </Col>
                <Col sm={ 6 }>
                  <Field name="HandlingCost" component={ DisabledInputField } />
                </Col>
              </Row>
              <Row>
                <Col sm={ 6 }>
                  <label><Translate value="misc" /><span className="dollar-sign">$$</span></label>
                </Col>
                <Col sm={ 6 }>
                  <Field name="MiscCost" component={ DisabledInputField } />
                </Col>
              </Row>
              <Row>
                <Col sm={ 6 }>
                  <label><Translate value="shipping" /><span className="dollar-sign">$$</span></label>
                </Col>
                <Col sm={ 6 }>
                  <Field name="ShippingCost" component={ DisabledInputField } />
                </Col>
              </Row>
            </Col>
            <Col xs={ 2 }>
              <label className="receive-form-label"><Translate value="receiving_details" /></label>
                <Row>
                  <Col sm={ 6 }>
                    <label><Translate value="po" /><span className="dollar-sign">$$</span></label>
                  </Col>
                  <Col sm={ 6 }>
                    {numberWithCommas(POPrice)}
                  </Col>
                </Row>
                <Row>
                  <Col sm={ 6 }>
                    <label><Translate value="receiving" /><span className="dollar-sign">$$</span></label>
                  </Col>
                  <Col sm={ 6 }>
                    {numberWithCommas(ReceivingPrice)}
                  </Col>
                </Row>
                <Row>
                  <Col sm={ 6 }>
                    <label><Translate value="total" /><span className="dollar-sign">$$</span></label>
                  </Col>
                  <Col sm={ 6 }>
                    {numberWithCommas(totalPrice)}
                  </Col>
                </Row>
                <Row>
                  <Col sm={ 6 }>
                    <label><Translate value="final" /><span className="dollar-sign">$$</span></label>
                  </Col>
                  <Col sm={ 6 }>
                    {numberWithCommas(finalPrice)}
                  </Col>
                </Row>
                {this.renderPaymentStatus()}
            </Col>
        </Panel>
      )
    }

    header() {
      return (
        <h2 className="mt0"><Translate value="purchase_record" /></h2>
      )
    }

    handleFormSubmit(formProps) {
      this.setState({dirty:false});
      if(!this.checkPermission("change_purchase_payment")){
        // var WarehouseReceiveCompleted_id = this.props.currentReceiveHistoryDetail.WarehouseReceiveCompleted_id;
        // var WarehouseReceive_id = this.props.currentReceiveHistoryDetail.WarehouseReceive_id;
        // if(this.state.files) {
        //   this.props.attachFile(formProps.PONum, this.state.files);
        // }
        const { currentReceiveHistoryDetail } = this.props;
        const { TotalPrice, FinalPrice } = currentReceiveHistoryDetail || {};
        this.props.editReceiveHistory(formProps, Data.Selectors.getRows(this.state), "isPayment", TotalPrice, FinalPrice);
      }
      else
        alert("You have no permission!");
    }

    checkPermission(permission) {
        return false;
    }

    renderPaymentStatus() {
         let paymentStatusOptions = [
            { value: 'Not Paid', label: 'Not Paid' },
             { value: 'Partially Paid', label: 'Partially Paid' },
             { value: 'Paid', label: 'Paid' },
         ];

         return (
                 <Row>
                   <Col sm={ 6 }>
                     <label><Translate value="payment_status" /> <span style={{color: 'red'}} >*</span> </label>
                  </Col>
                  <Col sm={ 6 }>
                    <Field name="PaymentStatus" component={Selection} options={paymentStatusOptions}/>
                  </Col>
                 </Row>
           )
    }

    render() {
        const { handleSubmit, submitting, pristine } = this.props;
        let imageURL = this.props.fetchedAttachedFiles && this.props.fetchedAttachedFiles.file;
        imageURL = imageURL || "";
        const tabTitle1 = <Translate value="purchase_record_details" />
        const tabTitle2 = <Translate value="attach_file" />
        if (this.props.detailIsLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{this.props.error.message}</div></ContentWrapper>
        else {
            return (
                <ContentWrapper>
                  <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                    <Breadcrumb>
                      <Breadcrumb.Item>
                        <Translate value="ar_slashsign_ap" />
                      </Breadcrumb.Item>
                      <Breadcrumb.Item active="true">
                        <Translate value="purchase_record_details" />
                      </Breadcrumb.Item>
                    </Breadcrumb>
                    <ButtonToolbar>
                      <Button onClick={()=>{this.context.router.push("/purchasePayment")}} bsStyle="danger"><em className="fa fa-close"/></Button>
                      <Button
                        className="btn btn-primary"
                        style={{ marginRight: "20px" }}
                        type="submit"
                        disabled={!checkPermission('change_purchase_payment')}
                    ><em className="fa fa-save" style={{ marginRight: "10px" }}/><Translate value="save" /></Button>
                    </ButtonToolbar>
                    <Grid fluid="true" id="purchase-payment-detail">
                      {/* <Row>
                        <Col sm={ 2 }>
                          <Link to="/purchasePayment" className="btn btn-default"><em className="fa fa-reply"/></Link>
                        </Col>
                        <Col sm={2} mdOffset={8}>
                          <Button
                            bsStyle="success pull-right">
                            <em className="fa fa-save" /><Translate value="save" />
                          </Button>
                        </Col>
                      </Row> */}
                      <Row>
                        {this.header()}
                        <h3>{this.props.currentReceiveHistoryDetail && this.props.currentReceiveHistoryDetail.WarehouseName}</h3>
                      </Row>
                      <Row>
                        {this.renderPOInformation()}
                      </Row>
                      <Tabs defaultActiveKey={ 1 } justified>
                        <Tab eventKey={ 1 } title={tabTitle1} className="table-collapse-fix">
                          {this.renderTable() }
                        </Tab>
                        <Tab eventKey={ 2 } title={tabTitle2} className="table-collapse-fix">
                          <Row>
                            <Col sm={3}>
                              <Dropzone onDrop={this.onDrop.bind(this)} className="well dropzone" >
                                  <Button
                                    bsStyle="primary"
                                    className="pull-right"
                                    onClick={this.onOpenClick}
                                    disabled={this.checkPermission("change_purchase_payment")}>
                                    <em className="fa fa-file-text" />
                                    <Translate value="upload" />
                                  </Button>
                                  <div className="dz-default dz-message"><Translate value="msg_drop_upload_files" /></div>
                              </Dropzone>
                              {this.state.files && this.renderPreview() }
                              <Button
                                bsStyle="danger"
                                className="pull-right"
                                onClick={this.deleteFile}
                                disabled={this.checkPermission("change_purchase_payment")}>
                                <em className="fa fa-trash-o" />
                                <Translate value="delete" />
                              </Button>
                            </Col>
                            <Col sm={9}>
                              <div className = "imgDiv">
                                <iframe src={imageURL}
                                  alt="Attached File"/>
                              </div>
                            </Col>
                          </Row>
                        </Tab>
                      </Tabs>
                  </Grid>
                </form>
              </ContentWrapper>
            );
        }
    }
}



export default PurchasePaymentDetail;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchasePaymentDetail.jsx